import { render, staticRenderFns } from "./BaseMenuSearchBar.vue?vue&type=template&id=2d7dbd9b"
import script from "./BaseMenuSearchBar.vue?vue&type=script&lang=js"
export * from "./BaseMenuSearchBar.vue?vue&type=script&lang=js"
import style0 from "./BaseMenuSearchBar.vue?vue&type=style&index=0&id=2d7dbd9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports